import CryptoJS from 'crypto-js'
const key = CryptoJS.enc.Latin1.parse('zhplugin') // 秘钥
const iv = CryptoJS.enc.Latin1.parse('nigulphz') // 常量
export function encrypt(data) {
  var srcs = CryptoJS.enc.Utf8.parse(data)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  return encrypted.toString()
}
export function decrypt(encrypted) {
  var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
